import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import {
    areEstimatorIntroductionStatesEqual,
    ESTIMATOR_INTRODUCTION_INITIAL_STATE,
} from './cost-to-build-client-ui-estimator-introduction.state';
import type { EstimatorIntroductionState } from './cost-to-build-client-ui-estimator-introduction.types';

export const EstimatorIntroductionStore = signalStore(
    withState(ESTIMATOR_INTRODUCTION_INITIAL_STATE),
    withComputed((store) => ({
        state: computed<EstimatorIntroductionState>(() => ({
            description: store.description(),
            title: store.title(),
        })),
    })),
    withMethods((store) => {
        const setState = (patch: Partial<EstimatorIntroductionState>) => {
            const nextState: EstimatorIntroductionState = {
                ...store.state(),
                ...patch,
            };

            if (areEstimatorIntroductionStatesEqual(store.state(), nextState)) {
                return;
            }

            patchState(store, patch);
        };

        return {
            setDescription(description: string) {
                setState({ description });
            },
            setState,
            setTitle(title: string) {
                setState({ title });
            },
        };
    })
);
